import React from 'react';

import { AutomationRecipientDetail, AutomationList, AutomationDetail } from '@hero/pages';

import { paths } from '../paths';

export const automationRoutes = [
  {
    path: paths.MY_AUTOMATION_LIST,
    element: <AutomationList />,
    state: {
      pageKey: 'AutomationList',
      metadata: {
        title: 'Automation list'
      }
    }
  },
  {
    path: paths.MY_AUTOMATION_DETAIL(),
    element: <AutomationDetail />,
    state: {
      pageKey: 'AutomationDetails',
      metadata: {
        title: 'Automation details'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.AUTOMATION_RECIPIENT_DETAIL(),
    element: <AutomationRecipientDetail />,
    state: {
      pageKey: 'AutomationRecipientDetail',
      metadata: {
        title: 'Recipient details'
      },
      shoppingCart: {
        enabled: false
      }
    }
  }
];
